import { render, staticRenderFns } from "./CardService.vue?vue&type=template&id=f8588b74&scoped=true&"
import script from "./CardService.vue?vue&type=script&lang=js&"
export * from "./CardService.vue?vue&type=script&lang=js&"
import style0 from "./CardService.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardService.vue?vue&type=style&index=1&id=f8588b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8588b74",
  null
  
)

export default component.exports